import { CButton, CNav, CNavItem, CNavLink } from '@coreui/react'
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import AntdTable from 'src/components/AntdTable/Table'
import { deleteClubItem, deleteClubService, editClubItem, getAbonementListClubItems, getAbonementListClubServices, getServices } from 'src/store/Slices/AbonementsSlice'
import AddNewAbonementServices from '../Modals/AddNewAbonementServices'
import AddNewAbonementClubServices from '../Modals/AddNewAbonementClubServices'
import { Switch, Dropdown } from 'antd'
import { openNotification } from 'src/components/helpers/notification'
import { DownOutlined } from '@ant-design/icons';
import SureModal from 'src/components/Modals/SureModal'
import EditNewAbonementServices from '../Modals/EditNewAbonementServices'
import EditNewAbonementClubServices from '../Modals/EditNewAbonementClubServices'
import { DeleteOutlined } from '@ant-design/icons';

const AbonementsServices = ({ setAbonementInfo, abonementCostInfo, mnemo }) => {

    // HELPERS
    const dispatch = useDispatch()
    const [tab, setTab] = useState('Состав пакета')

    const items = [
        {
            key: '1',
            label: 'Редактировать',
            onClick: () => { tab === 'Состав пакета' ? setIsOpenEditServices(true) : setIsOpenClubEditServices(true) },
            disabled: (!mnemo?.children?.find(el => el.name === (tab === 'Состав пакета' ? 'Состав пакета' : 'Услуги'))?.children.find(ele => ele.mnemo === 'updateBtn'))
        },
        {
            key: '2',
            label: 'Удалить',
            onClick: () => { setIsOpenDeleteModal(true) },
            disabled: (!mnemo?.children?.find(el => el.name === (tab === 'Состав пакета' ? 'Состав пакета' : 'Услуги'))?.children.find(ele => ele.mnemo === 'deleteBtn'))
        },
    ];

    // STATE
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(5)
    const [isOpenModalServ, setIsOpenModalServ] = useState(false)
    const [isOpenModalClubServ, setIsOpenModalClubServ] = useState(false)
    const [isDeleted, setIsDeleted] = useState(false)
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false)
    const [abonementServicesInfo, setbAonementServicesInfo] = useState()
    const [isOpenEditServices, setIsOpenEditServices] = useState(false)
    const [isOpenEditClubServices, setIsOpenClubEditServices] = useState(false)

    // STORE
    const abonementClubsItems = useSelector(state => state.AbonementsSlice.abonementClubsItems)
    const abonementClubsItemsLoading = useSelector(state => state.AbonementsSlice.abonementClubsItemsLoading)
    const abonementListClubServices = useSelector(state => state.AbonementsSlice.abonementListClubServices)
    const abonementListClubServicesLoading = useSelector(state => state.AbonementsSlice.abonementListClubServicesLoading)

    // FUNCTIONS
    const title = () => {
        return (
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <CNav variant="tabs">
                    <CNavItem>
                        <CNavLink
                            style={{ cursor: 'pointer' }}
                            onClick={() => { setTab('Состав пакета') }}
                            active={tab === 'Состав пакета'}
                        >
                            Состав пакета
                        </CNavLink>
                    </CNavItem>
                    <CNavItem>
                        <CNavLink
                            style={{ cursor: 'pointer' }}
                            onClick={() => { setTab('Услуги') }}
                            active={tab === 'Услуги'}
                        >
                            Услуги
                        </CNavLink>
                    </CNavItem>
                </CNav>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <Switch
                        disabled={(!mnemo?.children?.find(el => el.name === (tab === 'Состав пакета' ? 'Состав пакета' : 'Услуги'))?.children.find(ele => ele.mnemo === 'isDeletedBtn'))}
                        defaultValue={isDeleted}
                        checkedChildren={<DeleteOutlined />}
                        unCheckedChildren={<DeleteOutlined />}
                        onChange={() => {
                            setIsDeleted(!isDeleted)
                        }}
                        value={isDeleted}
                    />
                    {!isDeleted && <CButton
                        disabled={(!mnemo?.children?.find(el => el.name === (tab === 'Состав пакета' ? 'Состав пакета' : 'Услуги'))?.children.find(ele => ele.mnemo === 'insertBtn'))}
                        onClick={() => {
                            tab === 'Состав пакета' ? setIsOpenModalServ(true) : setIsOpenModalClubServ(true)
                        }} className='text-light' size='sm'>Добавить</CButton>}
                </div>
            </div>
        )
    }

    const handleTableChange = (pagination, filters, sorter) => {
        if (tab === 'Состав пакета') {
            dispatch(getAbonementListClubItems({
                AbonementClubId: abonementCostInfo.id,
                count: pagination.pageSize,
                offset: pagination.pageSize * (pagination.current - 1),
                orderBy: sorter?.column?.dataIndex,
                isDesc: sorter.order ? sorter.order === 'ascend' ? true : false : undefined,
                isDeleted: isDeleted
            }))
        } else {
            dispatch(getAbonementListClubServices({
                AbonementClubId: abonementCostInfo.id,
                count: pagination.pageSize,
                offset: pagination.pageSize * (pagination.current - 1),
                orderBy: sorter?.column?.dataIndex,
                isDesc: sorter.order ? sorter.order === 'ascend' ? true : false : undefined,
                isDeleted: isDeleted
            }))
        }
        setPage(pagination.current)
        setPageSize(pagination.pageSize)
    }

    const onClickRowOne = (record) => {
        setbAonementServicesInfo(record)
    }

    const onClickDelete = () => {
        if (tab === 'Состав пакета') {
            dispatch(deleteClubItem({
                clubItemId: abonementServicesInfo.id
            })).then(() => {
                dispatch(getAbonementListClubItems({ AbonementClubId: abonementCostInfo.id }))
                setIsOpenDeleteModal(false)
            })
        } else {
            dispatch(deleteClubService({ clubServiceId: abonementServicesInfo.id })).then(() => {
                dispatch(getAbonementListClubServices({
                    AbonementClubId: abonementCostInfo.id
                }))
                setIsOpenDeleteModal(false)
            })
        }
    }

    useEffect(() => {
        dispatch(getServices())
    }, [])

    useEffect(() => {
        if (tab === 'Состав пакета') {
            dispatch(getAbonementListClubItems({
                AbonementClubId: abonementCostInfo.id,
                count: pageSize,
                offset: pageSize * (page - 1),
                isDeleted: isDeleted
            }))
        } else {
            dispatch(getAbonementListClubServices({
                AbonementClubId: abonementCostInfo.id,
                count: pageSize,
                offset: pageSize * (page - 1),
                isDeleted: isDeleted
            }))
        }
    }, [isDeleted])

    useEffect(() => {
        setIsDeleted(false)
    }, [tab])

    const handleChargeEveryTimeHandler = (el) => {
        dispatch(editClubItem({
            id: el.id,
            itemName: el.itemName,
            chargeEveryTime: !el.chargeEveryTime
        })).then(() => {
            dispatch(getAbonementListClubItems({ AbonementClubId: abonementCostInfo.id }))
        })
    }

    const formatedAbonementClubsItemsRows = abonementClubsItems?.data?.value?.rows?.map(el => {
        return ({
            ...el,
            chargeEveryTime: (
                <Switch onClick={() => handleChargeEveryTimeHandler(el)} value={el?.chargeEveryTime} />
            )
        })
    })

    return (
        <>
            <AddNewAbonementServices
                visible={isOpenModalServ}
                setVisible={setIsOpenModalServ}
                abonementCostInfo={abonementCostInfo}
            />
            <EditNewAbonementServices
                visible={isOpenEditServices}
                setVisible={setIsOpenEditServices}
                abonementCostInfo={abonementCostInfo}
                abonementServicesInfo={abonementServicesInfo}
            />
            <AddNewAbonementClubServices
                visible={isOpenModalClubServ}
                setVisible={setIsOpenModalClubServ}
                abonementCostInfo={abonementCostInfo}
            />
            <EditNewAbonementClubServices
                visible={isOpenEditClubServices}
                setVisible={setIsOpenClubEditServices}
                abonementCostInfo={abonementCostInfo}
                abonementServicesInfo={abonementServicesInfo}
            />
            <SureModal
                visible={isOpenDeleteModal}
                setVisible={setIsOpenDeleteModal}
                onClickYes={onClickDelete}
            />
            <AntdTable
                pageSize={pageSize}
                setPageSize={setPageSize}
                page={page}
                setPage={setPage}
                loading={tab === 'Состав пакета' ? abonementClubsItemsLoading : abonementListClubServicesLoading}
                columns={tab === 'Состав пакета' ? abonementClubsItems &&
                    [...abonementClubsItems?.data?.value?.columns, {
                        title: 'Действия',
                        key: 'action',
                        align: 'center',
                        render: (_, record) => (
                            <Dropdown
                                menu={{
                                    items,
                                }}
                                disabled={isDeleted}
                            >
                                <a className="text-primary text-decoration-none">
                                    Действия <DownOutlined />
                                </a>
                            </Dropdown>
                        ),
                        width: 100
                    }] :
                    abonementListClubServices && [...abonementListClubServices?.data?.value?.columns, {
                        title: 'Действия',
                        key: 'action',
                        align: 'center',
                        render: (_, record) => (
                            <Dropdown
                                menu={{
                                    items,
                                }}
                                disabled={isDeleted}
                            >
                                <a className="text-primary text-decoration-none">
                                    Действия <DownOutlined />
                                </a>
                            </Dropdown>
                        ),
                        width: 100
                    }]
                }
                rows={tab === 'Состав пакета' ? formatedAbonementClubsItemsRows : abonementListClubServices?.data?.value?.rows}
                scroll={{ x: 0, y: 226 }}
                title={title}
                onClickRowOne={onClickRowOne}
                onChange={handleTableChange}
                total={tab === 'Состав пакета' ? abonementClubsItems?.data?.value?.totalCount : abonementListClubServices?.data?.value?.totalCount}
            />
        </>
    )
}

export default AbonementsServices